import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Container, ButtonGroup, Button } from 'reactstrap';
import { DateRangePicker } from 'react-dates';
import moment from 'moment';
import axiosInstance from '@src/axios-instance';
import { Chart } from 'react-google-charts';
import EOITypes from '@components/EvidenceOfInsurance/Types/Types';

class EvidenceOfInsuranceStatistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      focusedInput: false,
      startDate: moment().subtract(7, 'days'),
      endDate: moment(),
      displayType: 'day',
      graphOptions: [
        'total',
        'purchase',
        'refinance',
        'renewal',
        'b2b',
        'b2b-no-fee'
      ],
      eois: [],
      keys: []
    };
    this.loadDiagram();
  }

  updateParams = updateObj => {
    this.setState(updateObj, this.loadDiagram);
  };
  loadDiagram = () => {
    if (this.state.startDate === null || this.state.endDate === null) {
      return false;
    }
    const getData = {
      start_date: this.state.startDate.unix(),
      end_date: this.state.endDate.unix(),
      display_type: this.state.displayType
    };
    axiosInstance()
      .get('/evidence-of-insurances/dashboard.json', { params: getData })
      .then(response => {
        this.setState({
          eois: response.data.result,
          keys: response.data.keys
        });
      })
      .catch(err => {});
  };

  updateGraphOption = type => {
    let index = this.state.graphOptions.indexOf(type);
    const options = [...this.state.graphOptions];
    if (index === -1) {
      options.push(type);
    } else {
      options.splice(index, 1);
    }

    this.setState({
      graphOptions: options
    });
  };

  render = () => {
    const columns = [{ type: 'string', label: 'Day' }];
    const chartColors = [];
    if (this.state.graphOptions.indexOf('total') >= 0) {
      columns.push({ type: 'number', label: 'Total EOIs' });
      chartColors.push('#3b5249');
    }
    if (this.state.graphOptions.indexOf('purchase') >= 0) {
      columns.push({ type: 'number', label: 'Purchases' });
      chartColors.push('#00b7c2');
    }
    if (this.state.graphOptions.indexOf('refinance') >= 0) {
      columns.push({ type: 'number', label: 'Refinances' });
      chartColors.push('#fddb3a');
    }
    if (this.state.graphOptions.indexOf('renewal') >= 0) {
      columns.push({ type: 'number', label: 'Renewal' });
      chartColors.push('#ff5959');
    }
    if (this.state.graphOptions.indexOf('b2b') >= 0) {
      columns.push({ type: 'number', label: 'B2B (Billable)' });
      chartColors.push('#9c9427');
    }
    if (this.state.graphOptions.indexOf('b2b-no-fee') >= 0) {
      columns.push({ type: 'number', label: 'B2B ($0 Fee)' });
      chartColors.push('#05e386');
    }

    const eoiData = this.state.eois.map(item => {
      const tmp = [];
      tmp.push(item[0]);
      if (this.state.graphOptions.indexOf('total') >= 0) {
        tmp.push(item[1]);
      }
      if (this.state.graphOptions.indexOf('purchase') >= 0) {
        tmp.push(item[2]);
      }
      if (this.state.graphOptions.indexOf('refinance') >= 0) {
        tmp.push(item[3]);
      }
      if (this.state.graphOptions.indexOf('renewal') >= 0) {
        tmp.push(item[4]);
      }
      if (this.state.graphOptions.indexOf('b2b') >= 0) {
        tmp.push(item[5]);
      }
      if (this.state.graphOptions.indexOf('b2b-no-fee') >= 0) {
        tmp.push(item[6]);
      }
      return tmp;
    });
    const chartData = [columns, ...eoiData];

    console.log(chartData);
    return (
      <Container>
        <Helmet>
          <title>NXT Insurance Hub | EOIs</title>
        </Helmet>
        <h3>Evidence Of Insurance Statistics</h3>
        <div className={'justify-content-between d-flex'}>
          <div className={'mr-3'}>
            <ButtonGroup>
              {[
                'total',
                'purchase',
                'refinance',
                'renewal',
                'b2b',
                'b2b-no-fee'
              ].map(item => {
                const type = EOITypes.find(type => type.key === item);
                return (
                  <Button
                    color={
                      this.state.graphOptions.indexOf(item) >= 0
                        ? 'primary'
                        : 'secondary'
                    }
                    onClick={() => this.updateGraphOption(item)}
                  >
                    <span>{type === undefined ? item : type.label}</span>
                  </Button>
                );
              })}
            </ButtonGroup>
          </div>
          <div>
            <DateRangePicker
              startDate={this.state.startDate} // momentPropTypes.momentObj or null,
              startDateId="your_unique_start_date_id" // PropTypes.string.isRequired,
              endDate={this.state.endDate} // momentPropTypes.momentObj or null,
              endDateId="your_unique_end_date_id" // PropTypes.string.isRequired,
              isOutsideRange={() => false}
              onDatesChange={({ startDate, endDate }) =>
                this.updateParams({ startDate, endDate })
              } // PropTypes.func.isRequired,
              focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
              onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
            />
          </div>
          <div className={'ml-3'}>
            <ButtonGroup>
              <Button
                color={
                  this.state.displayType === 'day' ? 'primary' : 'secondary'
                }
                onClick={() => this.updateParams({ displayType: 'day' })}
              >
                Day
              </Button>
              <Button
                color={
                  this.state.displayType === 'week' ? 'primary' : 'secondary'
                }
                onClick={() => this.updateParams({ displayType: 'week' })}
              >
                Week
              </Button>
              <Button
                color={
                  this.state.displayType === 'month' ? 'primary' : 'secondary'
                }
                onClick={() => this.updateParams({ displayType: 'month' })}
              >
                Month
              </Button>
            </ButtonGroup>
          </div>
        </div>
        <div className={'pt-4'}>
          {this.state.eois.length > 0 && (
            <Chart
              width={'100%'}
              height={'400px'}
              chartType="LineChart"
              loader={<div>Loading Chart</div>}
              data={chartData}
              options={{
                legend: { position: 'top' },
                chartArea: { width: '80%', height: '70%' },
                hAxis: { title: 'Date' },
                vAxis: { title: 'EOIs Delivered', format: '0' },
                colors: chartColors,
                lineWidth: 3
              }}
            />
          )}
        </div>
      </Container>
    );
  };
}

export default EvidenceOfInsuranceStatistics;
